import { workflowAxiosPost } from "../utils/workflowAuthHeaders";

const BASE_URL = "https://workflow.grupocenze.com.br:38137/rest/";

/**
 * POST CRM_INCPV — finalização do pedido de venda no atendimento.
 * Body: cliente, loja, contato, vendedor, condpag, produtos, frete, frota, etc.
 */
const enviarPedidoVendas = async (
  requestBody,
  token,
  username,
  password,
  { empresa = "01", filial = "01" } = {},
) => {
  try {
    const response = await workflowAxiosPost(
      `${BASE_URL}CRM_INCPV`,
      requestBody,
      {
        params: {
          empresa,
          filial,
        },
      },
      { token, username, password },
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao enviar CRM_INCPV:", error);
    throw error;
  }
};

/** Extrai numero_pedido da resposta de sucesso do CRM_INCPV */
export function extractNumeroPedido(resposta) {
  if (resposta == null) return "";

  if (typeof resposta === "string" || typeof resposta === "number") {
    const s = String(resposta).trim();
    // tenta achar "numero_pedido": "123" ou numero_pedido=123 em texto
    const m = s.match(/numero_pedido["'\s:=]+["']?(\d+)/i);
    if (m) return m[1];
    return s;
  }

  if (typeof resposta !== "object") return "";

  const candidatos = [
    resposta.numero_pedido,
    resposta.numeroPedido,
    resposta.NUMERO_PEDIDO,
    resposta.pedido,
    resposta.numero,
    resposta.numero_atendimento,
    resposta.numeroAtendimento,
    resposta.data?.numero_pedido,
    resposta.data?.numeroPedido,
    resposta.result?.numero_pedido,
    resposta.result?.numeroPedido,
    resposta.message?.numero_pedido,
    resposta.msg?.numero_pedido,
  ];

  for (const c of candidatos) {
    if (c != null && String(c).trim() !== "") return String(c).trim();
  }

  // message como string com o número embutido
  const msg = resposta.message || resposta.msg || resposta.mensagem;
  if (typeof msg === "string") {
    const m = msg.match(/numero_pedido["'\s:=]+["']?(\d+)/i);
    if (m) return m[1];
    const m2 = msg.match(/(?:pedido|número|numero)\s*[:#]?\s*(\d{4,})/i);
    if (m2) return m2[1];
  }

  return "";
}

export default enviarPedidoVendas;
